import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { UPDATE_PASSWORD, RESET_PASSWORD } from "../Constants";
import { UpdatePasswordActionsSuccess, UpdatePasswordActionsFailure, ResetPasswordActionsSuccess, ResetPasswordActionsFailure } from "../Actions/UpdatePassword";

function* UpdatePasswordRequest(actions) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/update_forget_password`,
      {
        email: actions.payload.email,
        password: actions.payload.password,
        temp_token: actions.payload.temp_token,
        bankcode: actions.payload.bankcode,
      },
      { headers: { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
    );
    console.log(res);
    if (res.status === 200) {
      yield put(UpdatePasswordActionsSuccess(res.data));
    } else yield put(UpdatePasswordActionsFailure(res));
  } catch (e) {
    yield put(UpdatePasswordActionsFailure(e));
  }
}

function* ResetPasswordRequest(actions) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_URL}api/admin/reset_password_by_token`,
      {
        password: actions.payload.password,
        token: actions.payload.temp_token,
      },
      { headers: { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
    );
    console.log(res);
    if (res.status === 200) {
      yield put(ResetPasswordActionsSuccess(res.data));
    } else yield put(ResetPasswordActionsFailure(res));
  } catch (e) {
    yield put(ResetPasswordActionsFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(UPDATE_PASSWORD, UpdatePasswordRequest);
  yield takeLatest(RESET_PASSWORD, ResetPasswordRequest);
}

export default function* UpdatePasswordSaga() {
  yield all([actionWatcher()]);
}
